// extracted by css-extract-rspack-plugin
export default {"UploadImageContainer":"UploadImageContainer-T_G60W","uploadImageContainer":"UploadImageContainer-T_G60W"};